﻿import React, { useContext, useMemo } from 'react';
import Context, { context_type } from '@Util/Context';

import Featured_Projects from '@Elements/DynamicIsland/Featured_Projects';
import Stop_Current_Project_Button from '@Elements/DynamicIsland/Stop_Current_Project_Button';
import Current_Project_Ellapsed_Time from '@Elements/DynamicIsland/Current_Project_Ellapsed_Time';
import User_Menu from '@Elements/DynamicIsland/User_Menu';

export default function Dynamic_Island(): JSX.Element {
    const { current_project }: context_type = useContext(Context);

    const dynamicIslandClassName = useMemo(() => {
        let classStr = "Dynamic_Island";

        if (current_project?.customerName) {
            classStr += " Dynamic_Island_OngoingProject";
        }
        
        return classStr;
    }, [current_project]);

    return (
        <aside className={dynamicIslandClassName}>
            <div className="Dynamic_Island_InteractionBoard">
                {current_project?.customerName && <Current_Project_Ellapsed_Time />}
                <Featured_Projects />
                {current_project?.customerName && <Stop_Current_Project_Button />}
            </div>
            <User_Menu />
        </aside>
    );
}